import axios from "axios";
import { logout } from "../lib/auth";
import { paymentTableColumn } from "../config/payment";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

//  明細一覧取得
export async function getPayments(props: { [key: string]: number | string }) {
  try {
    const path = "payments";
    const params = makeParams(paymentTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const payments: dataDifine[] = response.data.fetch_data;
    const countPayments: string = response.data.count_data;
    const allCheckFlg: boolean = response.data.all_check_flg;
    return { payments, countPayments, allCheckFlg };
  } catch (error) {
    // logout();
  }
}

// 明細詳細取得
export async function getPayment(props: { [key: string]: number | string }) {
  try {
    const path = "payment";
    const params = {
      payment_year: props.payment_year,
      payment_month: props.payment_month,

      contract_number: props.contract_number,
      product_name: props.product_name,
      service_name: props.service_name,
      trading_type: props.trading_type,
      unique_payment_name: props.unique_payment_name,
      pm_payment_method: props.pm_payment_method,
      ctt_payment_method: props.ctt_payment_method,
      customer_phone_number: props.customer_phone_number,
      payment_company_status: props.payment_company_status,
      high_rank_company_name: props.high_rank_company_name,
      payment_sale_company_name: props.payment_sale_company_name,
    };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {
    // logout();
  }
}
